import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueGtag from "vue-gtag"
import router from '@/router'

let id = ['GTM-NS4LXRG', 'GTM-TFQW8VF']
let uaId = process.env.VUE_APP_GOOGLE_ANALYTICS_UA_SERVER
if (window.thinkmd && window.thinkmd.gtag) {
    id.push(window.thinkmd.gtag)
}

Vue.use(VueGtm, {
    id: id,
    //  queryParams: {},
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [] // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.use(VueGtag, {
    config: {
        id: uaId
    }
}, router)